/**
 * v3 — bath appliances + faucets. Each tier owns its own registration
 * file so parallel-agent merges stay conflict-free; the main index
 * just imports each tier's registrations.
 *
 * Variant fields used (discovered via grep — see PR body for full table):
 *   - toilet:                obj.mountType ('wall-hung'); obj.subtype/style for one-piece (no canonical field today)
 *   - bathtub:               obj.tubType (alcove | freestanding | drop-in | undermount); obj.style for clawfoot
 *   - kitchen-sink:          obj.subtype (undermount | drop-in | farmhouse); basinCount inferred from width
 *   - sink (bathroom):       obj.sinkType (undermount | vessel | dropin | pedestal | wall-mount)
 *   - kitchen-faucet:        no canonical body-style field; falls back to subtype/style/spoutStyle
 *   - bathroom-sink-faucet:  obj.mountType (widespread | centerset | single-handle | wall-mount)
 *   - bathroom-tub-faucet:   obj.wallMounted (boolean); falls back to mountType / subtype / style
 *   - showerhead:            no canonical field; subtype/style/headType
 *   - shower-controls:       no canonical field; subtype/style/controlType
 */
import { registerSchematic } from './registry';
import { ToiletSchematic } from './ToiletSchematic';
import { BathtubSchematic } from './BathtubSchematic';
import { KitchenSinkSchematic } from './KitchenSinkSchematic';
import { SinkSchematic } from './SinkSchematic';
import { KitchenFaucetSchematic } from './KitchenFaucetSchematic';
import { BathroomSinkFaucetSchematic } from './BathroomSinkFaucetSchematic';
import { BathroomTubFaucetSchematic } from './BathroomTubFaucetSchematic';
import { ShowerheadSchematic } from './ShowerheadSchematic';
import { ShowerControlsSchematic } from './ShowerControlsSchematic';

registerSchematic('toilet', ToiletSchematic);
registerSchematic('bathtub', BathtubSchematic);
registerSchematic('kitchen-sink', KitchenSinkSchematic);
registerSchematic('sink', SinkSchematic);
registerSchematic('kitchen-faucet', KitchenFaucetSchematic);
registerSchematic('bathroom-sink-faucet', BathroomSinkFaucetSchematic);
registerSchematic('bathroom-tub-faucet', BathroomTubFaucetSchematic);
registerSchematic('showerhead', ShowerheadSchematic);
registerSchematic('shower-controls', ShowerControlsSchematic);

export {
  ToiletSchematic,
  BathtubSchematic,
  KitchenSinkSchematic,
  SinkSchematic,
  KitchenFaucetSchematic,
  BathroomSinkFaucetSchematic,
  BathroomTubFaucetSchematic,
  ShowerheadSchematic,
  ShowerControlsSchematic,
};
